import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import InventorySearchForm from './InventorySearchForm';
import InventorySearchResults from './InventorySearchResults';

const styles = () => ({
  root: {
    position: 'relative',
  },
});

class InventorySearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showResults: false,
      justFocused: false,
      justClickedResults: false,
      selectedIndex: 0,
    };

    this.onFormFocus = this.onFormFocus.bind(this);
    this.onFormBlur = this.onFormBlur.bind(this);
    this.onFormKeyDown = this.onFormKeyDown.bind(this);
    this.onResultsClick = this.onResultsClick.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
  }

  componentWillUnmount() {
    clearTimeout(this.focusTimeout);
    clearTimeout(this.blurTimeout);
    clearTimeout(this.resultsClickTimeout);
  }

  onFormFocus() {
    this.setState({
      showResults: true,
      justFocused: true,
    });
    this.focusTimeout = setTimeout(() => {
      this.setState({ justFocused: false });
    }, 300);
  }

  onFormBlur() {
    this.blurTimeout = setTimeout(() => {
      const {
        justClickedResults,
        justFocused,
      } = this.state;
      if (!justClickedResults
        && !justFocused) {
        this.setState({ showResults: false });
      } else {
        this.setState({
          justClickedResults: false,
          justFocused: false,
        });
      }
    }, 200);
  }

  onResultsClick() {
    this.setState({ justClickedResults: true });
    this.resultsClickTimeout = setTimeout(() => {
      this.setState({ justClickedResults: false });
    }, 300);
  }

  onClickAway() {
    this.setState({
      showResults: false,
      justClickedResults: false,
      justFocused: false,
    });
  }

  onFormKeyDown(event) {
    const { inventory, onResultsItemClick } = this.props;
    const { selectedIndex } = this.state;
    switch (event.key) {
      case 'Enter': {
        onResultsItemClick(inventory[selectedIndex]);
        this.setState({
          showResults: false,
        });
        break;
      }
      case 'ArrowDown': {
        const newSelectedIndex = inventory.length <= selectedIndex + 1
          ? 0 : selectedIndex + 1;
        this.setState({ selectedIndex: newSelectedIndex });
        break;
      }
      case 'ArrowUp': {
        const newSelectedIndex = selectedIndex === 0
          ? inventory.length - 1 : selectedIndex - 1;
        this.setState({ selectedIndex: newSelectedIndex });
        break;
      }
      default:
    }
  }

  render() {
    const {
      inventory,
      filters,
      loading,
      onInventoryCreateButtonClick,
      onScrollFetchRequest,
      onResultsItemClick,
      onSubmitButtonClick,
      onCancelButtonClick,
      submitButtonDisabled,
      searchDisabled,
      submitButtonLoading,
      submitButtonText,
      cancelButtonText,
      classes,
    } = this.props;
    const { showResults, selectedIndex } = this.state;
    return (
      <ClickAwayListener onClickAway={this.onClickAway}>
        <div className={classes.root}>
          <InventorySearchForm
            onFocus={this.onFormFocus}
            onBlur={this.onFormBlur}
            onKeyDown={this.onFormKeyDown}
            onSubmitButtonClick={onSubmitButtonClick}
            onCancelButtonClick={onCancelButtonClick}
            submitButtonDisabled={submitButtonDisabled}
            searchDisabled={searchDisabled}
            submitButtonLoading={submitButtonLoading}
            submitButtonText={submitButtonText}
            cancelButtonText={cancelButtonText}
            searchInputRef={(searchInputRef) => {
              if (searchInputRef) {
                if (!this.searchInputRefArray) {
                  this.searchInputRefArray = [searchInputRef];
                } else if (!this.searchInputRefArray.find(item => item.id === searchInputRef.id)) {
                  this.searchInputRefArray.push(searchInputRef);
                }
              }
            }}
          />
          {(showResults && Object.keys(filters).length > 0) &&
            <InventorySearchResults
              loading={loading}
              inventory={inventory}
              onInventoryCreateButtonClick={() => {
                if (this.searchInputRefArray) {
                  this.searchInputRefArray.forEach((searchInputRef) => {
                    searchInputRef.blur();
                  })
                }
                onInventoryCreateButtonClick();
              }}
              onScrollFetchRequest={onScrollFetchRequest}
              onResultsItemClick={(values) => {
                this.setState({
                  showResults: false,
                });
                onResultsItemClick(values);
              }}
              onClick={this.onResultsClick}
              selectedIndex={selectedIndex}
              onCloseClick={(this.onClickAway)}
            />
          }
        </div>
      </ClickAwayListener>
    );
  }
}

InventorySearch.propTypes = {
  inventory: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  filters: PropTypes.shape({
    'Product Name': PropTypes.string,
    'Vendor Name': PropTypes.string,
    Model: PropTypes.string,
  }),
  loading: PropTypes.number.isRequired,
  onInventoryCreateButtonClick: PropTypes.func,
  onScrollFetchRequest: PropTypes.func,
  onResultsItemClick: PropTypes.func,
  onSubmitButtonClick: PropTypes.func,
  onCancelButtonClick: PropTypes.func,
  submitButtonDisabled: PropTypes.bool,
  searchDisabled: PropTypes.bool,
  submitButtonLoading: PropTypes.bool,
  submitButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

InventorySearch.defaultProps = {
  onInventoryCreateButtonClick: null,
  onScrollFetchRequest: () => {},
  onResultsItemClick: () => {},
  filters: {},
  onSubmitButtonClick: null,
  onCancelButtonClick: null,
  submitButtonDisabled: null,
  searchDisabled: false,
  submitButtonLoading: null,
  submitButtonText: null,
  cancelButtonText: null,
};

export default withStyles(styles)(InventorySearch);



// WEBPACK FOOTER //
// ./src/components/inventory/InventorySearch/InventorySearch.js